import styled from 'styled-components';

import { CardPlanWrapper } from '../current-plan/CardPlan/Wrapper';

export const Description = styled.div`
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 20px;
`;

export const CardWrapper = styled(CardPlanWrapper)`
  margin-bottom: 30px;
`;
